import React from 'react';
import styled from '@emotion/styled';
import { Heading, Flex, Text, Box } from 'roo-ui/components';
import { useSelector } from 'react-redux';
import { themeGet } from 'styled-system';
import { getDestination } from 'store/destination/destinationSelectors';
import Markdown from 'components/Markdown/Markdown';

const Question = styled(Box)`
  font-weight: ${themeGet('fontWeights.bold')};
  margin-bottom: ${themeGet('space.3')};
  margin-top: ${themeGet('space.5')};
`;

const QuestionAnswerBlock = (questionAnswerPair) => {
  const { question, mdAnswer: answer } = questionAnswerPair;
  return (
    <Flex flexDirection="column" itemScope itemProp="mainEntity" itemType="https://schema.org/Question" data-testid="question-answer-block">
      <Question fontSize={['base', 'md']} itemProp="name" data-testid="question">
        {question}
      </Question>

      <Text mb={4} fontSize={['sm', 'base']} itemScope itemProp="acceptedAnswer" itemType="https://schema.org/Answer" data-testid="answer">
        <Markdown content={answer} itemProp="text" />
      </Text>
    </Flex>
  );
};

const FAQs = () => {
  const { faqs } = useSelector(getDestination);

  return (
    <Box width={[1, 2 / 3]} mx={'auto'} p={0}>
      <Heading textAlign="center">Frequently Asked Questions</Heading>
      <Flex flexDirection="column" data-testid="questions-answers-wrapper">
        {faqs.map((questionAnswerPair, index) => (
          <QuestionAnswerBlock key={`faq-${index}`} {...questionAnswerPair} />
        ))}
      </Flex>
    </Box>
  );
};

export default FAQs;
